import { createFileRoute } from "@tanstack/react-router";

import CompetitionCircuits from "@/components/CompetitionProfile/CompetitionCircuits";

const Component = () => {
  const { competitionUuid } = Route.useParams();

  return <CompetitionCircuits competitionUuid={competitionUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/profile/circuits")({
  component: Component,
});
